<template>
    <footer v-if="checkPages" class="footer">
        <div class="container">
             <div class="pure-g">

                <div class="pure-u-1 pure-u-md-2-3 pure-u-lg-14-24 left">
                    <nav>
                        <router-link to="/" class="logo no-opacity">{{ $store.state.site.name }}</router-link>
                        <router-link to="/">Home</router-link>
                        <router-link to="/events">Events</router-link>
                        <router-link to="/workshops">Workshops</router-link>
                        <router-link to="/about">About Us</router-link>
                        <router-link to="/stories">Stories</router-link>
                        <!-- <router-link to="/news">News</router-link> -->
                        <router-link to="/members">Members</router-link>
                        <router-link to="/listings">Listings</router-link>
                    </nav>
                    <p class="copyright">All Rights Reserved. © {{ currentYear }} {{ $store.state.site.name }} Community.</p>
                </div>

                <div class="pure-u-1 pure-u-md-1-3 pure-u-lg-10-24 right">
                    <nav class="socialMenu">
                        <a href="https://www.facebook.com/onemglcom" target="_blank" class="facebook"><ion-icon name="logo-facebook"></ion-icon></a>
                        <a href="https://www.instagram.com/onemglcom/" target="_blank" class="instagram"><ion-icon name="logo-instagram"></ion-icon></a>
                        <a href="https://www.youtube.com/channel/UCjyVpUoJtbVBYcOeC58qG3Q" target="_blank" class="youtube"><ion-icon name="logo-youtube"></ion-icon></a>
                    </nav>
                    <p class="websiteBy"><a href="https://www.ananddavaasuren.com" target="_blank">Design &amp; Development by Anand Davaasuren.</a></p>
                </div>  

             </div>
        </div>
    </footer>
</template>

<script>
import moment from 'moment'

export default {
    data(){
        return{
            currentYear: ''
        }
    },

    mounted(){
        this.currentYear = moment().format('YYYY')
    },

    computed: {
        checkPages(){
            let pages = [
                'Resources',
                'Friends',
                'Chat'
            ]

            if(pages.includes(this.$route.name)){
                return false
            }

            return true
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/components/Footer.vue